import api from 'Cloud/Application/api';
import config from 'Cloud/config';
import { sendDwh } from 'reactApp/utils/ga';
import { roundCustom } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { SearchApiRequestParams } from './search.types';

const apiVersion = api.getOptions().version;
const buildVersion = config.get('BUILD');
interface ISearchStatisticsParams {
    kaktam: {
        label: string;
        data: {
            time: number;
            query?: string;
            searchType?: string;
            resultsCount?: number;
            resultCount?: number;
            offset?: number;
        };
    };
    status: number;
    apiRequestDeltaT: number;
}

const sendRadarStatistics = (radarGroup: 'search' | 'virus-scan', params: ISearchStatisticsParams) => {
    const {
        apiRequestDeltaT,
        status,
        kaktam: { label, data },
    } = params;
    const deltaT = roundCustom(Math.round(apiRequestDeltaT), [0, 10, 100, 250, 500, 750, 1000, 2000, 3000, 4000, 5000, 10000]);

    const radar = RADAR.group(radarGroup);

    if (status === 200) {
        radar.add('success_all', deltaT);
    } else {
        radar.add('fail_all', deltaT);
        radar.add(`fail_status-${status}_all`, deltaT);
    }

    radar.kaktam(label, JSON.stringify(data));

    radar.send();
};

export const sendVirusScanStatistics = (status: number, apiRequestDeltaT: number, offset: number, resultsCount: number) => {
    sendRadarStatistics('virus-scan', {
        apiRequestDeltaT,
        status,
        kaktam: {
            label: 'virus-scan',
            data: {
                time: apiRequestDeltaT,
                offset,
                resultsCount,
            },
        },
    });
};

export const sendSearchStatistics = (status: number, query: string, searchType: string, apiRequestDeltaT: number, resultCount: number) => {
    sendRadarStatistics('search', {
        apiRequestDeltaT,
        status,
        kaktam: {
            label: 'search',
            data: {
                time: apiRequestDeltaT,
                query,
                searchType,
                resultCount,
            },
        },
    });
};

export const sendSearchAnalytics = (params: SearchApiRequestParams, place: string, xPageId: string, xReqId: string) => {
    const { q, path, limit, ext } = params;

    sendDwh({
        eventCategory: ECategoryGa.search,
        action: 'enter',
        dwhData: {
            page_id: xPageId,
            req_id: xReqId,
            api: apiVersion,
            build: buildVersion,
            q,
            path,
            limit,
            ext,
            place,
        },
    });
};

export const sendSearchInputClickRadar = ({ storage }) => {
    sendPaymentGa({
        eventCategory: ECategoryGa.search,
        action: 'initial_click',
        q: '',
        path: '/',
        section: storage,
        api: apiVersion,
        build: buildVersion,
    });
};

export const sendSearchRadarAnalytics = ({ eventCategory, action, ...other }, items: any[] = []) => {
    let dwhData = other;
    if (items?.filter((item) => !!item).length) {
        dwhData = {
            ...dwhData,
            name_files: items.map(({ nameWithoutExt }) => nameWithoutExt).join(', '),
            type_content: items.map(({ kind, subKind }) => kind || subKind).join(', '),
            pos: items.map(({ pos }) => pos).join(', '),
            hash: items.map(({ hash }) => hash).join(', '),
            size: items.map(({ size }) => size || 0).join(', '),
        };
    }
    sendDwh({
        eventCategory,
        action,
        dwhData,
    });
};
